import React from "react";
import Layout from "../components/layout";
import SEO from "../components/seo";
import { graphql } from "gatsby"
import Img from "gatsby-image"
import { Link } from "../../.cache/gatsby-browser-entry"


export const FileLink = ({ element, tag }) =>
{
	if (element) {
		return <a href={element} className="btn btn-outline-dark btn-sm me-2" target="__blank">{tag}</a>;
	}

	return null;
}

export const ExternalLink = ({ element, tag }) =>
{
	if (element) {
		return <a href={element} className="btn btn-outline-dark btn-sm me-2" target="__blank">{tag}</a>;
	}

	return null;
}

export const InternalLink = ({ element, tag }) =>
{
	if (element) {
		return <Link to={element} className="btn btn-outline-dark btn-sm me-2">{tag}</Link>
	}

	return null;
}

export const ProjectPageLink = ({ project, slug, tag }) =>
{
	if (project) {
		const ext = project.split('.').pop();
		if (ext === "md") {
			return <InternalLink element={slug} tag={tag} />
		} else {
			return <ExternalLink element={project} tag={tag} />
		}
	}

	return null;
}

export const is_external = ({project}) =>
{
	if (project)
	{
		const ext = project.split('.').pop();
		if (ext === "md") {
			return false;
		} else {
			return true;
		}
	}
	else
	{
		return false;
	}

}

export const PaperHeadline = ({ paper, title }) =>
{
	if (paper.frontmatter.project)
	{
		if (is_external(paper.frontmatter.project))
		{
			return <a href={paper.frontmatter.slug}
					  className="text-decoration-none"
					  target="__blank">
				{title}
			</a>
		}
		else
		{
			return <Link to={paper.frontmatter.slug}
						 className="text-decoration-none">
				{title}
			</Link>
		}
	}
	else if (paper.frontmatter.arxiv)
	{
		return <a href={paper.frontmatter.arxiv}
				  className="text-decoration-none"
				  target="__blank">
			{title}
		</a>
	}
	else if (paper.frontmatter.pdf)
	{
		return <a href={paper.frontmatter.pdf}
				  className="text-decoration-none"
				  target="__blank">
			{title}
		</a>
	}

	return paper.frontmatter.title;
}

export default function Research ({ data }) {
	const papers = data.papers.nodes;

	return (
		<Layout>
			<SEO title="Research" />

			{/* Publications */}
			<h2 className="text-center" style={{marginBottom: -50}}>Publications</h2>

			<div className="container px-5 mx-5">
				{papers.map(paper => (
					<div className="row" style={{paddingTop: 104}} id={paper.frontmatter.slug}>
						<div className="col-12 col-md-4 mb-5 mb-md-0">
							<PaperHeadline paper={paper} title={<Img fluid={paper.frontmatter.thumb.childImageSharp.fluid}
																	 style={{width: 300}} className="mx-auto"/>}/>

						</div>
						<div className="col-12 col-md-8">
							<div className="text-center text-md-start fs-3">
								{/*{paper.frontmatter.title}*/}
								<PaperHeadline paper={paper} title={paper.frontmatter.title}/>
							</div>
							{/*<h6 dangerouslySetInnerHTML={{__html: paper.frontmatter.authors}}>{paper.frontmatter.authors}</h6>*/}
							<div className="text-muted text-center text-md-start" dangerouslySetInnerHTML={{__html: paper.frontmatter.authors }} />
							<p className="my-2 text-center text-md-start"><em>{paper.frontmatter.conference} ({paper.frontmatter.conference_short})  - {paper.frontmatter.year}</em></p>
							<div className="text-center text-md-start">
								<FileLink element={paper.frontmatter.bibtex} tag={"BibTex"} />
								<FileLink element={paper.frontmatter.pdf} tag={"PDF"} />
								{/*<a href="#" className="btn btn-outline-dark btn-sm me-2">Project</a>*/}
								<ExternalLink element={paper.frontmatter.arxiv} tag={"Arxiv"} />
								<ExternalLink element={paper.frontmatter.youtube} tag={"Video"} />
								<ExternalLink element={paper.frontmatter.code} tag={"Code"} />
								<ProjectPageLink project={paper.frontmatter.project} slug={paper.frontmatter.slug} tag={"Project"} />
							</div>
						</div>

					</div>
				))}

			</div>
		</Layout>
	);
}


export const query = graphql`
query ResearchPage {
  papers: allMarkdownRemark(
  	sort: {fields: frontmatter___date, order: DESC}
  	filter: {fileAbsolutePath: {regex: "/(src/papers)/"}}
  ) {
		nodes {
			frontmatter {
				title
				conference
				conference_short
				slug
				year
				authors
				thumb {
				  childImageSharp {
				  	fluid {
						...GatsbyImageSharpFluid
					}
				  }
				}
				pdf
				bibtex
				code
				arxiv
				youtube
				project
			}
			id
		}
	}

}
`

